import { AddIcon, ArrowUpIcon, ConvertIcon } from '@approvalmax/ui';
import { Button, Flex } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { DropdownMenu } from '../DropdownMenu/DropdownMenu';
import { useHandlers } from './WalletsTabActions.hooks';
import { messages } from './WalletsTabActions.messages';

export const WalletsTabActions = memo(() => {
    const { isLoading, handleConvertClick, handleFundClick } = useHandlers();

    if (isLoading) {
        return (
            <Flex alignItems='center'>
                <Skeleton width={100} height={40} />

                <Skeleton width={100} height={40} />

                <Skeleton width={100} height={40} />

                <Skeleton width={24} height={40} />
            </Flex>
        );
    }

    return (
        <Flex alignItems='center'>
            <Button color='white100' startIcon={<ArrowUpIcon />}>
                {messages.send}
            </Button>

            <Button color='white100' startIcon={<AddIcon />} onClick={handleFundClick}>
                {messages.addFunds}
            </Button>

            <Button color='white100' startIcon={<ConvertIcon />} onClick={handleConvertClick}>
                {messages.convert}
            </Button>

            <DropdownMenu />
        </Flex>
    );
});

WalletsTabActions.displayName = 'WalletsTabActions';
